export const SHOW_END_HOUR_INTERVAL = 3;
